// @tennis-matches/services/winterdoppel/billing

import { getSupabaseClient } from "../supabase/index.js";
import { getWinterDoppelSeries } from "./series.js";
import { assertWinterDoppelPlanEditable } from "./planLock.js";

function __asStr(v) {
  return String(v ?? "").trim();
}

export const WINTERDOPPEL_PARTICIPANT_PRICING_HOURLY_SPLIT = "hourly_split";
export const WINTERDOPPEL_PARTICIPANT_PRICING_PER_PARTICIPANT =
  "per_participant_hourly";

const BILLING_SELECT =
  "id,tenant_id,created_by,series_id,court_fee,hourly_rate,charge_planned_participants,participant_pricing_mode,participant_hourly_rate,created_at,updated_at";

function normalizeParticipantPricingMode(value) {
  const mode = __asStr(value);
  if (mode === WINTERDOPPEL_PARTICIPANT_PRICING_PER_PARTICIPANT) {
    return WINTERDOPPEL_PARTICIPANT_PRICING_PER_PARTICIPANT;
  }
  return WINTERDOPPEL_PARTICIPANT_PRICING_HOURLY_SPLIT;
}

export async function loadWinterDoppelSeriesBilling(seriesId) {
  const supabase = await getSupabaseClient();
  const { data, error } = await supabase
    .from("winterdoppel_series_billing")
    .select(BILLING_SELECT)
    .eq("series_id", __asStr(seriesId))
    .maybeSingle();
  if (error) throw error;
  return data || null;
}

export async function upsertWinterDoppelSeriesBilling(
  seriesId,
  {
    courtFee,
    hourlyRate,
    chargePlannedParticipants,
    participantPricingMode,
    participantHourlyRate,
    tenantId,
  } = {},
) {
  const series = await getWinterDoppelSeries(seriesId);
  if (!series) throw new Error("winterdoppel.series.notFound");
  assertWinterDoppelPlanEditable(series);

  const fee = Math.max(0, Number(courtFee) || 0);
  const hourly = Math.max(0, Number(hourlyRate) || 0);
  const supabase = await getSupabaseClient();
  const row = {
    series_id: __asStr(seriesId),
    court_fee: fee,
    hourly_rate: hourly,
  };
  if (chargePlannedParticipants !== undefined) {
    row.charge_planned_participants = Boolean(chargePlannedParticipants);
  }
  if (participantPricingMode !== undefined) {
    row.participant_pricing_mode = normalizeParticipantPricingMode(
      participantPricingMode,
    );
  }
  if (participantHourlyRate !== undefined) {
    const rate = Number(participantHourlyRate);
    row.participant_hourly_rate =
      Number.isFinite(rate) && rate > 0 ? Math.round(rate * 100) / 100 : null;
  }
  const tid = __asStr(tenantId || series.tenant_id);
  if (tid) row.tenant_id = tid;

  const { data, error } = await supabase
    .from("winterdoppel_series_billing")
    .upsert(row, { onConflict: "series_id" })
    .select(BILLING_SELECT)
    .single();
  if (error) throw error;
  return data;
}
